import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Label = styled.div.withConfig({
  displayName: "partials__Label",
  componentId: "sc-1ihk9uu-0"
})(["", " font-weight:400;color:", ";"], getFont(-1), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.fontL;
});